import React, { useEffect, useState } from 'react'
import {
    Box,
    Typography,
} from '@mui/material';

import LargeKeyValue from '../../components/display/LargeKeyValue';
import ShortDataGrid from '../../components/datagrid/ShortDataGrid';


export default function ShotDetailPageDesktop(props) {
    const {
        shotData
    } = props

    const columns = [
        { field: 'key', headerName: 'Metadata', flex: 1 },
        { field: 'value', headerName: 'Value', flex: 1 },
    ];

    return (
        <React.Fragment>
            <Box
                display="flex"
                flexDirection="column" 
                width='100%'
                height='100%'
            >
                <Box
                mx={3}
                mt={3}
                display={'flex'}
                flexDirection={'row'}
                height={'200px'}
                >
                    {
                        Object.keys(shotData).includes('thumbnail')
                        ?
                        <img
                            alt="thumbnail"
                            width="350px"
                            height="197px"
                            src={`data:image/png;base64, ${shotData.thumbnail}`}
                        />
                        :
                        <Box height='197px' width='350px' />

                    }
                    <Box display="flex" 
                        flexDirection="column" 
                        m={3}
                    >
                        <Typography sx={{color: 'white'}} variant="h5" paddingBottom='20px'>{shotData.ClipName}</Typography>

                        <Box display="flex" flexWrap="wrap" justifyContent="space-between" width="300px">
                            <LargeKeyValue label="Transfer Date" value={shotData.TransferDate} />
                            <LargeKeyValue label='Episode' value={shotData.Episode} />
                            <LargeKeyValue label='Scene' value={shotData.Scene} />
                            <LargeKeyValue label='Take' value={shotData.Take} />
                            <LargeKeyValue label='Camera' value={shotData.Camera} />
                        </Box> 
                    </Box>
                </Box>
                <Box
                    display='flex'
                    flexDirection='row'
                    height='100%'
                    m={3}
                >
                    {shotData?.metadata && <Box
                        width='50%'
                        height='100%'
                        mx={0.5}
                    >
                        <Box
                            width='100%'
                            height='100%'
                        >
                         <ShortDataGrid 
                            rows={shotData?.metadata || []}
                            columns={columns} 
                            pageSize={18} 
                            rowHeight={50} />
                        </Box>
                    </Box>
                    }
                    {shotData?.Framedata && <Box
                        width='50%'
                        height='100%'
                        mx={0.5}
                    >
                        <Box
                            width='100%'
                            height='100%'
                        >
                        <ShortDataGrid 
                            rows={shotData?.Framedata || []}
                            columns={shotData?.framecols || columns} 
                        />
                        </Box>
                    </Box>}
                </Box>
            </Box>
        </React.Fragment>
    )
}